var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadingBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 12,
    viewBox: "0 0 188 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0849 10.8419C23.4457 12.2443 30.8933 11.9297 38.0789 10.5831C51.92 7.9885 70.8692 7.63361 89.3443 7.18258C113.764 6.58472 138.943 6.50954 165.059 7.0761C171.677 7.22071 177.899 7.00336 184.082 6.82258C186.437 6.7541 189.185 6.57979 187.2 5.36941C185.587 4.38319 183.264 4.1653 180.107 3.72801C155.493 0.316642 134.57 1.06946 112.857 0.631521C83.2592 0.0347041 54.8169 0.337447 29.2009 2.29742C19.8001 3.01712 11.3929 4.11402 4.18831 5.67338C1.10159 6.34223 -1.11846 7.1619 1.2917 8.80887C3.9378 10.6149 8.36714 10.7337 11.0849 10.8419Z",
    fill: "#73828F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingBottom);
export default __webpack_public_path__ + "static/media/headingBottom.f308cb0307ad80b565fc371aa70b48a5.svg";
export { ForwardRef as ReactComponent };